/*
 * The english translation of: LiveContentBox, NewsSearchBox, TeamToolBox, ResetBox & PublishToolBox
 */
export const REMAINING_BOXES_EN = {
  newsSearch: 'News Search',
  urlParser: 'URL Parser',
  share: 'Share',
  approval: 'Approval',
  team: 'Team',
  editorZoom: 'Editor Zoom',
  dragMode: 'Drag Mode',
  resetToolboxStyle: 'Reset Toolbox Style',
  newStart: 'Restart',
  viewBox: 'View',
  additionalContent: 'Additional ComTask',
  readMore: 'Read more',
  addText: 'Text has been added',
  replaceText: 'Text has been replaced',
  openContent: 'Open Content',
  tasks: 'Tasks',
  errorLoadingData: 'Failed to load data',
  drafts: 'Drafts',
  draft: 'Draft',
  transcription: 'Transcription'
}
/*
 * The german translation of: LiveContentBox, NewsSearchBox, TeamToolBox, ResetBox & PublishToolBox
 */
export const REMAINING_BOXES_DE = {
  newsSearch: 'News-Suche',
  urlParser: 'URL-Parser',
  share: 'Teilen',
  approval: 'Freigeben',
  team: 'Team',
  editorZoom: 'Editor-Zoom',
  dragMode: 'Drag-Modus',
  resetToolboxStyle: 'Toolbox zurücksetzen',
  newStart: 'Neu starten',
  viewBox: 'Ansicht',
  additionalContent: 'Zusätzliche ComTasks',
  readMore: 'Mehr lesen',
  addText: 'Text wurde hinzugefügt',
  replaceText: 'Text wurde ersetzt',
  openContent: 'Inhalt öffnen',
  tasks: 'Aufgaben',
  errorLoadingData: 'Daten konnten nicht geladen werden',
  drafts: 'Entwürfe',
  draft: 'Entwurf',
  transcription: 'Transkription'
}
